// Scripts to place before closing body tag

// Currency switch function
function currencyFormSubmit(event) {
    event.target.form.submit();
}

// Event listeners for currency switching
document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
});